module.exports = __webpack_public_path__ + "media/images/rank/diamond-md-0195552cbc439539c747093c0c15520b.svg";